import { combineReducers } from 'redux';
import Reducer from './Reducer';
import { persistedReducer } from '../persistConfig';
import UserReducer from './UserReducer';

const RootReducer = combineReducers({
  user: Reducer
});

export default persistedReducer(RootReducer);